__turbopack_context__.v({
  "backgroundImage": "ImageTitleCtaSection-module__rYbzVq__backgroundImage",
  "contentWrapper": "ImageTitleCtaSection-module__rYbzVq__contentWrapper",
  "downloadButton": "ImageTitleCtaSection-module__rYbzVq__downloadButton",
  "sectionContainer": "ImageTitleCtaSection-module__rYbzVq__sectionContainer",
  "subtitle": "ImageTitleCtaSection-module__rYbzVq__subtitle",
  "title": "ImageTitleCtaSection-module__rYbzVq__title",
});
